import { render, staticRenderFns } from "./bodega-luigi-bosca.vue?vue&type=template&id=4c22e78d&scoped=true"
import script from "./bodega-luigi-bosca.vue?vue&type=script&lang=js"
export * from "./bodega-luigi-bosca.vue?vue&type=script&lang=js"
import style0 from "./bodega-luigi-bosca.vue?vue&type=style&index=0&id=4c22e78d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c22e78d",
  null
  
)

export default component.exports